import { Alert } from 'appkit-react';
import React, { useEffect, useState } from 'react';

const defaultStyle = {
    position: 'fixed',
    top: '4rem',
    left: '6rem',
    boxShadow: '1px 1px 10px 1px grey',
    zIndex: 1,
};

const DefaultAlert = ({
    toastMessage, setToastMessage, customStyle = defaultStyle, displayOneLine = true,
}) => {
    const [timer, setTimer] = useState(5);
    const id = React.useRef(null);
    const clear = () => {
        window.clearInterval(id.current);
    };

    useEffect(() => {
        id.current = window.setInterval(() => {
            setTimer(time => time - 1);
        }, 1000);
        return () => clear();
    }, []);

    useEffect(() => {
        if (timer === 0) {
            clear();
            setToastMessage('');
        }
    }, [timer]);

    const result = toastMessage.split('@').filter(ele => ele !== '');
    const messages = result.map((m, index) => (<div key={m} style={{ marginTop: '0.5rem' }}>{`${result.length > 1 ? `${index + 1} : ` : ''} ${m}`}</div>));
    return (
        <Alert
            className="a-example-alert"
            duration={5}
            status="success"
            message={messages}
            closeable
            onClose={() => setToastMessage('')}
            style={customStyle}
            oneLineDisplay={displayOneLine}
        />
    );
};

export default DefaultAlert;
